import { NgTemplateOutlet } from '@angular/common'
import { Component, input } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { RouterLink } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { NotificationCounterPipe } from '../../pipes/notification-counter.pipe'

export interface NavigationCardConfig {
  routerLink: string
  title?: string
  iconName?: string
  iconSrc?: string
  badgeCount?: number
  isExternalLink?: boolean
  testId?: string
  // If set replace the default white background color and the hover color
  backgroundColor?: string
  // Accessible label for screen readers (required when title is not provided)
  ariaLabel?: string
}

@Component({
  selector: 'app-navigation-card',
  templateUrl: './navigation-card.component.html',
  styleUrls: ['./navigation-card.component.scss'],
  imports: [MatIconModule, NgTemplateOutlet, RouterLink, TranslatePipe, NotificationCounterPipe],
})
export class NavigationCardComponent {
  readonly config = input.required<NavigationCardConfig>()
}
